const SET_APP                              = 'SET_APP';

const SET_DOWN_FOR_MAINTENANCE             = 'SET_DOWN_FOR_MAINTENANCE';

const SET_RATE_LIMIT                      = 'SET_RATE_LIMIT';

export const state = () => initialState();

function initialState () {
	return { 
	    down_for_maintenance:false,
      rate_limited:false,
	    app:{
	      version_increment:false,
	      refresh_local_cache_increment:false,
	      api_version:false
	    }
	}
}


export const mutations = {

/**
    * Add ab item to the basket
    * @type {object} basket item
    */
    [SET_APP](state, value) {
      state.app = value;
    },

    [SET_DOWN_FOR_MAINTENANCE](state, value){
      state.down_for_maintenance = value;
    },

    [SET_RATE_LIMIT](state, value){
      state.rate_limited = value;
    }

}

export const getters = {
    getApp: (state) => {
      return state.app;
    },
    getDownForMaintenance: (state) => {
      return state.down_for_maintenance;
    },
    getRateLimited: (state) => {
      return state.rate_limited;
    },
}